export const unt_valid_email_extensions = [
    'unt.edu',
    'my.unt.edu',
    'untsystem.edu',
    'admissions.unt.edu',
    'registrar.unt.edu',
    'housing.unt.edu',
    'financialaid.unt.edu',
    'library.unt.edu',
    'it.unt.edu',
    'business.unt.edu',
    'engineering.unt.edu',
    'education.unt.edu',
    'music.unt.edu',
    'journalism.unt.edu',
    'art.unt.edu',
    'health.unt.edu',
    'police.unt.edu',
    'careercenter.unt.edu',
    'international.unt.edu',
    'research.unt.edu',

    // Add more emails extensions here
];